var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from "react";
import { MenuButton as ChakraMenuButton, Text, Flex, useMenuStyles, } from "@chakra-ui/react";
import SvgSpriteConsumer from "../SvgSprite/SvgSpriteConsumer";
const DropdownMenuButton = (_a) => {
    var { icon, title, isOpen, dropDownIconVisible = true, titleVisible = true, "aria-label": ariaLabel } = _a, rest = __rest(_a, ["icon", "title", "isOpen", "dropDownIconVisible", "titleVisible", "aria-label"]);
    const computedAriaLabel = useMemo(() => {
        if (ariaLabel) {
            return ariaLabel;
        }
        if (!title) {
            return isOpen ? "Close menu" : "Open menu";
        }
        return title;
    }, [title, isOpen, ariaLabel]);
    const styles = useMenuStyles();
    return (_jsxs(ChakraMenuButton, Object.assign({ sx: styles.button }, rest, { "aria-label": computedAriaLabel, title: title }, { children: [icon || null, title && titleVisible ? (_jsx(Text, Object.assign({ noOfLines: 1, sx: styles.buttonTitle, as: "span", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }, { children: title }))) : null, dropDownIconVisible ? (_jsx(Flex, Object.assign({ sx: styles.indicator }, { children: _jsx(SvgSpriteConsumer, { svgId: isOpen ? "chevronUp24" : "chevronDown24", size: 24 }) }))) : null] })));
};
DropdownMenuButton.displayName = "DropdownMenuButton";
export default DropdownMenuButton;
//# sourceMappingURL=DropdownMenuButton.js.map